export enum ReportsTabs {
  Sequence = 'sequence',
  Team = 'team',
  Email = 'email',
  EmailWarmupReport = 'email-warmup-report',
}

export enum ReportsBy {
  ByEmailWarmupReport = 'email-warmup-report',
  ByProspects = 'prospect',
  ByEmail = 'email',
}

export enum SequenceReportSortBy {
  SequenceCreatedAt = 'createdAt',
  TotalProspects = 'totalProspects',
  ProspectsAdded = 'prospectAdded',
  ProspectContacted = 'prospectContacted',
  EmailsSent = 'emailSent',
  Opened = 'opened',
  Clicked = 'clicked',
  Replied = 'replied',
  Bounced = 'bounced',
  Unsubscribed = 'unSubscribed',
  Owner = 'userName',
  Uncategorized = 'Uncategorized',
  SequenceId = 'sequenceId',
  PositiveSentiment = 'positive',
  NegativeSentiment = 'negative',
  NeutralSentiment = 'neutral',
  Interested = 'Interested',
  NotInterested = 'Not Interested',
  MeetingBooked = 'Meeting Booked',
  OutOfOffice = 'Out of Office',
  Closed = 'Closed',
  NotNow = 'Not Now',
  DoNotContact = 'Do Not Contact',
}

export enum ReportCountBy {
  Relative = 'relative',
  Absolute = 'absolute',
}

export enum Granularity {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
}

export type ProviderDistributionStats = {
  emailsSent: number;
  inbox: {
    count: number;
    percentage: number;
  };
  spam: {
    count: number;
    percentage: number;
  };
};

export type ProviderDistribution = {
  name: string;
  percentage: number;
  color: string;
  icon: string;
  stats: ProviderDistributionStats;
};

export type EmailWarmupCircularProgressProps = {
  deliverabilityScore?: Record<string, any> | null;
  isLoading?: boolean;
  /** When true: show blurred placeholder ring + locked provider rows (Free/Starter or missing meta resource). */
  isDeliverabilityLocked?: boolean;
  onRequestUpgrade?: () => void;
};
